import { axiosInstance } from "@/config/axios";
import { z } from "zod";
import { objectToCamel } from "ts-case-convert";
import { zipSchema } from "@/types/schemas/address";

const ruianSchema = z.object({
  ruianCode: z.number(),
  ruianId: z.number(),
  street: z.string(),
  houseNumber: z.nullable(z.number()),
  streetNumber: z.nullable(z.number().or(z.string())),
  registrationNumber: z.number().nullable(),
  city: z.string(),
  cityPart: z.string(),
  zip: zipSchema,
});
export const ruianAddressResponseSchema = z.array(ruianSchema);

export type Ruian = z.infer<typeof ruianSchema>;

export const getRuian = async (params: { query?: string }) => {
  const response = await axiosInstance.get("/ruian/search", {
    params: {
      ...params,
    },
  });
  const parsedResponse = z.object({ data: ruianAddressResponseSchema }).safeParse(objectToCamel(response.data));
  if (!parsedResponse.success) {
    console.error("zod error", parsedResponse.error.issues);
    return [];
  }
  return parsedResponse.data.data;
};

const cadastralTerritorySchema = z.object({
  name: z.string(),
  code: z.number(),
});
export const cadastralTerritoryResponseSchema = z.array(cadastralTerritorySchema);

export type RuianCadastralTerritory = z.infer<typeof cadastralTerritorySchema>;

export const getRuianCadastralTerritory = async (params: { query?: string }) => {
  const response = await axiosInstance.get("/ruian/search_cadastral_territory", {
    params,
  });
  const parsedResponse = z.object({ data: cadastralTerritoryResponseSchema }).safeParse(objectToCamel(response.data));
  if (!parsedResponse.success) {
    console.error("zod error", parsedResponse.error.issues);
    return [];
  }
  return parsedResponse.data.data;
};
